module.exports = __webpack_public_path__ + "static/media/mulefoot-leatherworking-tool.af9bcd78.webp";